import * as d3 from 'd3'

export default {

  methods: {
    getNode(id, name='width') {
      if(!this.svg.select(id).node()) return 0
      return this.svg.select(id).node().getBoundingClientRect()[name]
    },


    gmx_maxBound5(num) {
      if(isNaN(num)) return 0

      let autoValues = [5, 10, 15, 20, 25, 40, 50, 75, 100, 125, 150, 200, 250, 300, 400, 500, 750, 1000, 1250, 1500, 2000, 2500, 3000, 4000, 5000, 7500, 10000, 12500, 15000, 17500, 20000, 25000, 30000, 40000, 50000, 75000, 100000]
      let valid_ = autoValues.find(val => val >= num)
      let increment_ = 100

      while(!valid_) {
        valid_ = autoValues.map(m => m * increment_).find(val => val > num)
        increment_ = increment_ * 100
      }
      return valid_
    },

    gmx_maxBound3(num) {
      if(isNaN(num)) return 0

      let autoValues = [3,6, 9, 12, 15, 30, 45, 60, 90, 120, 150, 180, 210, 240, 300, 450, 600, 900, 1200, 1500, 1800, 2100, 2400, 3000, 4500, 6000, 9000, 12000, 15000, 18000, 21000, 24000, 30000, 36000, 45000, 60000, 90000]
      let valid_ = autoValues.find(val => val >= num)
      let increment_ = 100

      while(!valid_) {
        valid_ = autoValues.map(m => m * increment_).find(val => val > num)
        increment_ = increment_ * 100
      }
      return valid_
    },

    gmx_maxBound2(num) {
      if(isNaN(num)) return 0

      let autoValues = [10, 20, 50, 80, 100, 120, 150, 200, 250, 300, 400, 500, 700, 1000, 1200, 1500, 2000, 2500, 3000, 4000, 5000, 8000, 10000, 12500, 15000, 17500, 20000, 25000, 30000, 40000, 50000, 75000, 100000]
      let valid_ = autoValues.find(val => val >= num)
      let increment_ = 100

      while(!valid_) {
        valid_ = autoValues.map(m => m * increment_).find(val => val > num)
        increment_ = increment_ * 100
      }
      return valid_
    },


    gmx_minBound(num) {
      if(isNaN(num)) return 0
      let autoValues = [1000, 750, 500, 400, 300, 250, 200, 150, 125, 100, 75, 50, 30, 25, 20, 15, 10, 5, 0, 15, 20, 25, 30, 40, 50, 75, 100]
      return autoValues.find(val => val < num)
    },


    gmx_deltaValue(num, type) {
      if (type == null) {
        if(num == 0) return '#bcbcbc'
        if(num > 0) return '#44A9DF'
        if(num < 0) return '#F35E90'
      } else if (type == 'icon') {
        if(num ==0) return ''
        if(num > 0) return 'M3.6,6.8c0,0.5,0,6.4,0,6.4h4.3c0,0,0-6,0-6.4s3.6,0,3.6,0L5.8,0L0,6.8C0,6.8,3.6,6.2,3.6,6.8z'
        if(num < 0) return 'M7.9,6.4c0-0.5,0-6.4,0-6.4H3.6c0,0,0,6,0,6.4c0,0.4-3.6,0-3.6,0l5.8,6.8l5.8-6.8C11.6,6.4,7.9,7,7.9,6.4z'
      }
    },
    

    gmx_dateDiff(d1, d2) {
      const date1 = new Date(d1)
      const date2 = new Date(d2)
      const diffDate = date1.getTime() - date2.getTime()
      
      return (diffDate / (1000 * 60 * 60 * 24))
    },


    gmx_matrix(id) {
      let matrix = (id.attr('transform') || '').match(/matrix(.*?)\)/g)
      matrix = matrix[0].match(/-?\d+\.?(\d+)?/g)
      
      if(matrix.length == 6) var coordinate = {
        x: parseInt(matrix[4]), y: parseInt(matrix[5])
      }; else coordinate = {
        x: parseInt(matrix[6]), y: parseInt(matrix[7])
      }
      return coordinate
    },
    
    gmx_capitalizeWords(str) {
      if (!str) return ''

      return str
      .split(' ')
      .map(word => 
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(' ')
    }
    


  }
}
